module.exports = __webpack_public_path__ + "media/images/icons/flags/MX-0a13e7dee115915cf27b1d1d1b860b11.svg";